import Body from "./Body";
import Search from "./Search";
import PayDebt from "./PayDebt";
import UserInfo from "./userInfo";

export const Components = {
  Body,
  Search,
  PayDebt,
  UserInfo,
};
